import OfferSelect from './OfferSelect'

export default OfferSelect
